import React, { createContext, useState, useEffect } from 'react';

export const UserContext = createContext();

// Fonction pour récupérer le contexte utilisateur depuis le local storage
const getUserContextFromLocalStorage = () => {
  const userContextString = localStorage.getItem('userContext');
  return userContextString !== null && userContextString !== undefined
    ? JSON.parse(userContextString)
    : { isAuthenticated: false, username: '', is_staff: false, has_seen_confetti: false };
};

export const UserProvider = ({ children }) => {
  const [userContext, setUserContext] = useState(getUserContextFromLocalStorage());

  useEffect(() => {
    localStorage.setItem('userContext', JSON.stringify(userContext));
  }, [userContext]);

  const logout = () => {
    try {
      setUserContext({
        isAuthenticated: false,
        username: '',
        is_staff: false,
        has_seen_confetti: false,
      });
      localStorage.removeItem('userContext');
      localStorage.removeItem('accessToken');
      localStorage.removeItem('refreshToken');
      window.location.href = '/login';
    } catch (error) {
      console.error('Error logging out:', error);
      throw error;
    }
  };

  return (
    <UserContext.Provider value={{ userContext, setUserContext, logout }}>
      {children}
    </UserContext.Provider>
  );
};
